import { hashStringToNumber } from '@/utils/chart';

export const chartColors = [
  '#5B41FF',
  '#FF4B78',
  '#FF8828',
  '#F5D835',
  '#42D936',
  '#22EDCE',
  '#AE01BF',
  '#DC1D92',
  '#C71C6F',
  '#4B5E88',
  '#7614D2',
  '#FF3D39',
  '#EB7211',
  '#C8A817',
  '#84C61A',
  '#00937D',
  '#3265FF',
  '#F269FF',
  '#FF30AF',
  '#FF7EAD',
  '#1DC9E2',
  '#6A8FFF',
  '#FF7774',
  '#FFAC69',
  '#E6D46B',
  '#9AE62C',
  '#57CD70',
  '#83B5C7',
  '#794DC6',
  '#B961C2',
  '#CB3A37',
  '#7F4837',
  '#117C28',
  '#5C2CAF',
  '#7FDBDD',
  '#B8E66B',
  '#9F45FF',
  '#FFD1AC',
  '#64D4FF',
  '#00AE94',
  '#BA719E',
  '#BDB2FF',
  '#BAFFB2',
  '#FFB2B3',
  '#9C9D9D',
];

export const getChartColorByHash = (hashKey: string) => {
  const value = hashStringToNumber(hashKey);
  return chartColors[value % chartColors.length];
};
